// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

export default function HRImpTypeRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['HRImpTypeSelect']
   const premierImpPermission =
      state.featurePermissions['PremierImplementation']

   // If coreImp is not in the pricebook then hide the row
   if (
      state.product_list[`${state.coreProductSelected}Imp`]?.NotInPricebook ||
      state.product_list[`${state.coreProductSelected}PremierImp`]
         ?.NotInPricebook
   ) {
      return <></>
   }

   if (state.coreProductSelected === 'core0') {
      return
   } else if (
      state.user_view == 'Internal' ||
      (state.productCoreEECount >=
         state.product_list[`${state.coreProductSelected}Imp`]['EmpLow'] &&
         state.productCoreEECount <=
            state.product_list[`${state.coreProductSelected}Quickstart`][
               'EmpHigh'
            ])
   ) {
      // const checked = new Array(3);

      // // If Self Setup was selected, then the value must have been >= 21. If they then decrease it to 20 or less, we set it back to Quick Start.
      // if (state.productCoreEECount < 1 && (state.impType === state.impTypes[0].value || state.impType == null)) {
      //     checked[0] = false;
      //     checked[1] = true;
      //     checked[2] = false;
      //     state.setImpType("quickstart");
      // }
      // // If Quick Start is selected and they increase the value > EmpHigh (25), then we set it to Full.
      // else if (state.productCoreEECount > state.product_list[`${state.coreProductSelected}Quickstart`]['EmpHigh'] && (state.impType === state.impTypes[1].value || state.impType == null)) {
      //     checked[0] = false;
      //     checked[1] = false;
      //     checked[2] = true;
      //     state.setImpType("full");
      // }
      // // If Full is selected and they decrease the value to less than EmpLow, then we set it to Quick Start.
      // else if (state.productCoreEECount < state.product_list[`${state.coreProductSelected}Imp`]['EmpLow'] && (state.impType === state.impTypes[2].value || state.impType == null)) {
      //     checked[0] = false;
      //     checked[1] = true;
      //     checked[2] = false;
      //     state.setImpType("quickstart");
      // }
      // else {
      //     checked[0] = (state.impType === state.impTypes[0].value);
      //     checked[1] = (state.impType === state.impTypes[1].value);
      //     checked[2] = (state.impType === state.impTypes[2].value);
      // }

      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.productCoreEECount > 0 &&
               state.user_view != 'External' &&
               permissions.includes(state.user_role) ? (
                  <div className='form-check form-check-inline'>
                     <input
                        className='form-check-input'
                        type='radio'
                        name='inlineRadioOptions1'
                        id='imp1Radio'
                        value={state.impTypes[0].value}
                        checked={state.impType === state.impTypes[0].value}
                        onChange={state.onImpOptionChange}
                     ></input>
                     <label className='form-check-label'>
                        {state.impTypes[0].name}
                     </label>
                  </div>
               ) : (
                  ''
               )}
               {state.productCoreEECount >
                  state.product_list[`${state.coreProductSelected}Quickstart`][
                     'EmpLow'
                  ] &&
                  state.productCoreEECount <=
                     state.product_list[
                        `${state.coreProductSelected}Quickstart`
                     ]['EmpHigh'] && (
                     <div className='form-check form-check-inline'>
                        <input
                           className='form-check-input'
                           type='radio'
                           name='inlineRadioOptions1'
                           id='imp2Radio'
                           value={state.impTypes[1].value}
                           checked={state.impType === state.impTypes[1].value}
                           onChange={state.onImpOptionChange}
                        ></input>
                        <label className='form-check-label'>
                           {state.impTypes[1].name}
                        </label>
                     </div>
                  )}
               {state.productCoreEECount >=
                  state.product_list[`${state.coreProductSelected}Imp`][
                     'EmpLow'
                  ] && (
                  <div className='form-check form-check-inline'>
                     <input
                        className='form-check-input'
                        type='radio'
                        name='inlineRadioOptions1'
                        id='imp3Radio'
                        value={state.impTypes[2].value}
                        checked={state.impType === state.impTypes[2].value}
                        onChange={state.onImpOptionChange}
                     ></input>
                     <label className='form-check-label'>
                        {state.impTypes[2].name}
                     </label>
                  </div>
               )}
               {state.productCoreEECount >=
                  state.product_list[`${state.coreProductSelected}PremierImp`][
                     'EmpLow'
                  ] &&
                  premierImpPermission.includes(state.user_role) && (
                     <div className='form-check form-check-inline'>
                        <input
                           className='form-check-input'
                           type='radio'
                           name='inlineRadioOptions1'
                           id='imp4Radio'
                           value={state.impTypes[3].value}
                           checked={state.impType === state.impTypes[3].value}
                           onChange={state.onImpOptionChange}
                        ></input>
                        <label className='form-check-label'>
                           {state.impTypes[3].name}
                        </label>
                     </div>
                  )}
            </div>
            <div className='col-bhr2'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
   }
}
